export class HistoryLogQueryKeys {
  constructor(private prefix: string) {}

  getHistoryLogs(suffix?: unknown) {
    if (suffix) {
      return [this.prefix, suffix];
    }
    return [this.prefix];
  }
}
